import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  max-width: 100%;
  padding: 0;
  background-color: var(--t-brand-bg-color);
  color: var(--t-brand-fg-color);
`;

export const HeaderWrapper = styled.div`
  margin-bottom: 2rem;

  @media (min-width: 768px) {
    margin-bottom: 2.5rem;
  }

  @media (min-width: 992px) {
    margin-bottom: 3rem;
  }
`;

export const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
`;

export const SwiperWrapper = styled.div`
  width: 100%;

  .swiper {
    width: 100%;
    height: auto;
    overflow: visible;
  }

  .swiper-slide {
    height: auto;
    display: flex;
    align-items: stretch;
  }

  .swiper-wrapper {
    align-items: stretch;
  }
`;

export const SlideContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const ControlsWrapper = styled.div<{ imageOverlay?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: ${({ imageOverlay }) => (imageOverlay ? '0' : '1.5rem')};
  padding: ${({ imageOverlay }) => (imageOverlay ? '0' : '0 1rem')};
  position: ${({ imageOverlay }) => (imageOverlay ? 'absolute' : 'relative')};
  bottom: ${({ imageOverlay }) => (imageOverlay ? '1rem' : 'auto')};
  left: ${({ imageOverlay }) => (imageOverlay ? '50%' : 'auto')};
  transform: ${({ imageOverlay }) => (imageOverlay ? 'translateX(-50%)' : 'none')};
  z-index: ${({ imageOverlay }) => (imageOverlay ? '10' : 'auto')};

  @media (min-width: 768px) {
    margin-top: ${({ imageOverlay }) => (imageOverlay ? '0' : '2rem')};
    padding: ${({ imageOverlay }) => (imageOverlay ? '0' : '0 1.5rem')};
    bottom: ${({ imageOverlay }) => (imageOverlay ? '1.5rem' : 'auto')};
  }

  @media (min-width: 992px) {
    margin-top: ${({ imageOverlay }) => (imageOverlay ? '0' : '2.5rem')};
    padding: ${({ imageOverlay }) => (imageOverlay ? '0' : '0 2rem')};
    bottom: ${({ imageOverlay }) => (imageOverlay ? '2rem' : 'auto')};
  }
`;
